import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMessengerBrandedStyle0 = cosmosIconCss;

const CosmosIconMessengerBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMessengerBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '81512816cad90c9bdefaa7113b6406c0086add5b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '148f4191f1af083620986e92297b18c37a571aca', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '63ded8101d21d993bd467af72864ffc814825a10', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 19.244c4.86 0 8.8-3.815 8.8-8.522C19.8 6.015 15.86 2.2 11 2.2c-4.86 0-8.8 3.815-8.8 8.522 0 2.56 1.165 4.856 3.01 6.418v1.725a.927.927 0 0 0 1.3.855l1.913-.847c.815.241 1.68.371 2.577.371Z", fill: "url(#a)" }), h("path", { key: '4ab27953df1a41d3ceb242cd53608635e80ffa32', d: "M8.893 8.91 6.34 12.4c-.274.375.218.824.593.542l2.179-1.64a.64.64 0 0 1 .757-.005l1.938 1.414a.848.848 0 0 0 1.173-.173l2.677-3.613c.277-.375-.219-.828-.594-.543l-2.304 1.754a.64.64 0 0 1-.76.008l-1.931-1.41a.848.848 0 0 0-1.176.177Z", fill: "#fff" }), h("defs", { key: '578a25e88ec48725bb896fbeff43f3dc7aa0eda9' }, h("linearGradient", { key: '0375eb796f3827773384a4f02560d6c1b0e1540d', id: "a", x1: "11", y1: "2.2", x2: "8.176", y2: "19.704", gradientUnits: "userSpaceOnUse" }, h("stop", { key: '7f9c87b9bbbc2dc8eeae0f7daa0ea178a9bfcabe', "stop-color": "#00B1FF" }), h("stop", { key: '250cd8c1f7d3f920c5aae79c40c4bb0af946211c', offset: "1", "stop-color": "#006BFF" }))))));
    }
    static get style() { return CosmosIconMessengerBrandedStyle0; }
}, [1, "cosmos-icon-messenger-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-messenger-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-messenger-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMessengerBranded$1);
            }
            break;
    } });
}

const CosmosIconMessengerBranded = CosmosIconMessengerBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMessengerBranded, defineCustomElement };
